/* import __COLOCATED_TEMPLATE__ from './performance.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type ReportingTemplates from 'embercom/services/reporting-templates';
import type CustomReportsService from 'embercom/services/custom-reports-service';
import type Report from 'embercom/models/reporting/custom/report';
import { tracked } from '@glimmer/tracking';
import type Chart from 'embercom/models/reporting/custom/chart';
interface Args {}

export default class Performance extends Component<Args> {
  @service declare reportingTemplates: ReportingTemplates;
  @service declare customReportsService: CustomReportsService;
  @service declare store: $TSFixMe;
  @tracked report?: Report;
  @tracked isLoading = true;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.loadReport();
  }

  async loadReport() {
    await this.reportingTemplates.loadTemplates();
    this.report = this.makeBaseTemplate();
    this.isLoading = false;
  }

  makeBaseTemplate() {
    return this.store.createRecord('reporting/custom/report', {
      id: this.customReportsService.generateID(),
      fromTemplate: true,
    });
  }

  willDestroy() {
    // We need to clear template report when the component is destroyed
    // otherwise when re-creating it we will have a clash of ids
    super.willDestroy();
    if (this.report) {
      this.report.charts.toArray().forEach((chart: Chart) => {
        chart.deleteRecord();
        this.store.unloadRecord(chart);
      });
      if (!this.report.isEmpty) {
        this.report.deleteRecord();
        this.store.unloadRecord(this.report);
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAutomation::Analyze::Performance': typeof Performance;
    'ai-automation/analyze/Performance': typeof Performance;
  }
}
